import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import queryString from 'qs';
import { BudgetActionCreators, AppActionCreators } from '../../../actions';
import { BudgetList } from '../Project/BudgetList';
import { RouteUrls } from '../../../configs/routeUrls';
import { DefaultOffice } from '../../../utils/enums';

class BudgetListContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			page: 1,
			size: props.pageSize,
			archiveListPage: 1,
			archiveListSize: props.archiveListSize
		};

		this.onSearchProjects = this.onSearchProjects.bind(this);
		this.onRedirectToPreview = this.onRedirectToPreview.bind(this);
		this.onRedirectToVote = this.onRedirectToVote.bind(this);
		this.onRedirectToProjectTask = this.onRedirectToProjectTask.bind(this);
	}

	componentDidMount() {
		this.props.getAllBudgets({
			isActual: true,
			page: this.state.page,
			size: this.props.pageSize,
			archiveListPage: this.state.archiveListPage,
			archiveListSize: this.props.archiveListSize
		});
		this.props.getArchiveBudgets({
			isActual: false,
			page: this.state.page,
			size: this.props.pageSize,
			archiveListPage: this.state.archiveListPage,
			archiveListSize: this.props.archiveListSize
		});
		this.props.setBreadcrumbs([{
			url: RouteUrls.Budget.list.actual,
			displayName: 'Budżet obywatelski'
		}])
	}

	componentDidUpdate(prevProps) {
		if (prevProps.pageSize !== this.props.pageSize) {
			const filter = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
			this.setState({
				page: 1,
				size: this.props.pageSize
			});
			this.props.getAllBudgets({
				...filter,
				isActual: true,
				page: 1,
				size: this.props.pageSize,
				archiveListPage: this.state.archiveListPage,
				archiveListSize: this.props.archiveListSize
			});
		}

		if (prevProps.archiveListSize !== this.props.archiveListSize) {
			const filter = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
			this.setState({
				archiveListPage: 1,
				archiveListSize: this.props.archiveListSize
			});
			this.props.getArchiveBudgets({
				...filter,
				isActual: false,
				page: this.state.page,
				size: this.props.pageSize,
				archiveListPage: 1,
				archiveListSize: this.props.archiveListSize
			});
		}
	}

	onSearchProjects(filter) {
		this.props.getAllBudgets({ ...filter });
	}

	onRedirectToVote(budgetYearValue, id) {
		this.props.goTo(RouteUrls.Budget.vote.voteFunc(budgetYearValue, id));
	}

	onRedirectToPreview(budgetYearValue, id) {
		this.props.goTo(RouteUrls.Budget.vote.previewFunc(budgetYearValue, id));
	}

	redirectToEdit(row) {
		this.props.goTo(`${RouteUrls.Budget.detail}/${row.id}`);
	}

	onRedirectToProjectTask(filter) {
		const query = queryString.stringify(filter, { addQueryPrefix: true });
		this.props.goTo(`${RouteUrls.Budget.projectTasks.list}${query}`);
	}

	render() {
		let query = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });
		const { page = 1, archiveListPage = 1 } = query;
		const { size, archiveListSize } = this.state;
		const {
			budgets,
			budgetTotals,
			isAuth,
			loggedOfficeId,
			archiveBudgets,
			archiveBudgetTotals,
			isArchiveBudgetLoading,
			isOnlyOneOffice,
			isProjectTaskSearching,
			budgetYears,
			districts,
			officeThematicAreas,
			projectTaskStatuses,
			defaultOffice,
            expand,
            setExpandStateItem
		} = this.props;

		return (
			<BudgetList
				isBudgetLoading={this.props.isBudgetLoading}
				isArchiveBudgetLoading={isArchiveBudgetLoading}
				budgets={budgets}
				archiveBudgets={archiveBudgets}
				isAuth={isAuth}
				loggedOfficeId={loggedOfficeId}
				onProjectDetails={(row) => this.redirectToEdit(row)}
				onProjectPreview={this.onRedirectToPreview}
				onProjectVote={this.onRedirectToVote}
				page={page}
				size={size}
				archiveListPage={archiveListPage}
				archiveListSize={archiveListSize}
				budgetTotals={budgetTotals}
				archiveBudgetTotals={archiveBudgetTotals}
				onSearchProject={this.onSearchProjects}
				onSearchArchiveProject={this.props.getArchiveBudgets}
				changePageSize={this.props.setPageSize}
				changeArchivePageSize={this.props.setArchivePageSize}
				isOnlyOneOffice={isOnlyOneOffice}
				isProjectTaskSearching={isProjectTaskSearching}
				budgetYears={budgetYears}
				districts={districts}
				officeThematicAreas={officeThematicAreas}
				projectTaskStatuses={projectTaskStatuses}
				defaultOffice={defaultOffice}
				onSearchProjectTask={this.onRedirectToProjectTask}
				onSetExpandStateItem={setExpandStateItem}
				expand={expand}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isAuth: state.app.isAuth,
		loggedOfficeId: state.app.loggedUser.officeId || DefaultOffice.NotSetted,
		isBudgetLoading: state.budget.isBudgetLoading,
		isArchiveBudgetLoading: state.budget.isArchiveBudgetLoading,
		budgets: state.budget.budgets,
		budgetTotals: state.budget.budgetTotals,
		archiveBudgets: state.budget.archiveBudgets,
		archiveBudgetTotals: state.budget.archiveBudgetTotals,
		pageSize: state.app.pageSize,
		archiveListSize: state.app.archivePageSize,
		isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
		isProjectTaskSearching: state.projectTask.isProjectTaskSearching,
		budgetYears: state.app.availableBudgetYears,
		districts: state.app.districts,
		officeThematicAreas: state.app.officeThematicAreas,
		projectTaskStatuses: state.app.projectTaskStatuses,
		defaultOffice: state.app.defaultOffice,
		expand: state.app.expand
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...BudgetActionCreators, ...AppActionCreators }, dispatch),
		...{ goTo: (url) => dispatch(push(url)) }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BudgetListContainer);
